import {Injectable} from '@angular/core';

import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';

@Injectable()
export class BoxHighlightService {
  constructor(private registrySvc: EditorRegistryService) {}

  highlightBox(key): void {
    if (!key) {
      return;
    }

    const graph = this.registrySvc.getEditorUI().editor.graph;
    const cell = graph.model.getCell(Number(key));

    cell.comp.instance.highlight();
  }
}
